"use client";
import React from "react";

interface PhoneticSuggestionsProps {
  suggestions: string[];
  onSelect: (suggestion: string) => void;
}

export function PhoneticSuggestions({
  suggestions,
  onSelect,
}: PhoneticSuggestionsProps) {
  if (suggestions.length === 0) return null;

  return (
    <div className="absolute top-[calc(100%+4px)] left-0 z-[60] flex items-center gap-2 p-1 bg-white/80 backdrop-blur-md border border-zinc-200/50 shadow-sm rounded-full animate-in fade-in duration-200 opacity-60 hover:opacity-100 transition-all">
      {suggestions.map((suggestion, index) => (
        <button
          key={suggestion + index}
          onClick={() => onSelect(suggestion)}
          className="group flex items-center gap-2 px-3 py-1 rounded-full hover:bg-zinc-100 transition-all duration-200"
        >
          <span className="text-lg font-bold text-zinc-900">{suggestion}</span>
          <span className="text-[10px] font-medium text-zinc-400 uppercase tracking-tighter">
            {index + 1}
          </span>
        </button>
      ))}
      <div className="h-4 w-[1px] bg-zinc-200 mx-1" />
      <span className="pr-3 text-[9px] font-bold text-zinc-400 uppercase tracking-widest">
        Alt + #
      </span>
    </div>
  );
}
